export default __webpack_public_path__ + "static/media/Toggle.f709a7c0.svg";